import { REPLY_CLASSIFICATION_LABEL_LABELS, type ReplyClassificationLabel } from '@marketing-hub/shared';
import { recordDetailShellStyles } from '@/components/workspace/RecordDetailShell';

export type ReplyClassificationSummary = {
  label: ReplyClassificationLabel;
  confidence: number;
  source: string;
  needs_review: boolean;
  reason?: string | null;
  overridden_label?: string | null;
};

type Props = { classification: ReplyClassificationSummary | null | undefined };

export function ReplyClassificationBadge({ classification }: Props) {
  if (!classification) return null;
  const effective = (classification.overridden_label ??
    classification.label) as ReplyClassificationLabel;
  const labelText = REPLY_CLASSIFICATION_LABEL_LABELS[effective] ?? effective;
  const pct = Math.round(classification.confidence * 100);
  const review = classification.needs_review;

  return (
    <span
      className={review ? recordDetailShellStyles.badgeWarn : recordDetailShellStyles.badgeMuted}
      title={`${classification.source}${classification.reason ? ` · ${classification.reason}` : ''}`}
    >
      Reply: {labelText} ({pct}%){review ? ' · review' : ''}
    </span>
  );
}
